import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  colors,
  makeStyles
} from '@material-ui/core';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import PeopleIcon from '@material-ui/icons/PeopleOutlined';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.green[600],
    height: 56,
    width: 56
  },
  differenceIcon: {
    color: colors.green[900]
  },
  differenceValue: {
    color: colors.green[900],
    marginRight: theme.spacing(1)
  }
}));


const TotalCustomers = ({ className, valor, titulo, cor, variacao, variacaoDesc, Icone, ...rest }) => {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              {titulo}
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              {valor}
            </Typography>
          </Grid>
          <Grid item>
            {/* <Avatar className={classes.avatar} > */}
            <Avatar style={{height: 56,width: 56, backgroundColor: cor}} >
              {Icone&&<Icone />}
              {!Icone&&<PeopleIcon />}
            </Avatar>
          </Grid>
        </Grid>
        {variacao&&<Box
          mt={2}
          display="flex"
          alignItems="center"
        >
          <ArrowUpwardIcon className={classes.differenceIcon} />
          <Typography
            className={classes.differenceValue}
            variant="body2"
          >
            {`${variacao}%`}
          </Typography>
          <Typography
            color="textSecondary"
            variant="caption"
          >
            {variacaoDesc||""}
          </Typography>
        </Box>}
      </CardContent>
    </Card>
  );
};

TotalCustomers.propTypes = {
  className: PropTypes.string,
  valor: PropTypes.string
};

export default TotalCustomers;
